import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import * as Sizes from './sizes';
import { Subtext } from './styles';

const Subtitle = forwardRef(
  (
    {
      as = 'p',
      size,
      weight = 500,
      italic = false,
      align,
      color = 'content',
      transform,
      marginBottom,
      style,
      children,
      ...props
    },
    ref
  ) => (
    <Subtext
      ref={ref}
      as={as}
      $size={size}
      $weight={weight}
      $italic={italic}
      $align={align}
      $color={color}
      $transform={transform}
      $marginBottom={marginBottom}
      style={style}
      {...props}
    >
      {children}
    </Subtext>
  )
);

Subtitle.propTypes = {
  as: PropTypes.node,
  size: PropTypes.oneOf(Object.values(Sizes)),
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  italic: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
  color: PropTypes.string,
  transform: PropTypes.oneOf(['none', 'uppercase', 'lowercase', 'capitalize']),
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node
};

export default Subtitle;
